import classNames from 'classnames'
import { createLocaleUrl } from 'discovericl/helpers/locale-tools'
import { LocaleSwitcherEntry } from 'tsconfig/craft-types'

type Props = {
  domain: string
  entry?: LocaleSwitcherEntry
  title?: string | null
  backgroundColor?: string
}

export const CLocaleSwitcherContent = ({
  domain,
  entry,
  title,
  backgroundColor,
}: Props) => {
  return (
    <div
      className="md:pb-6 max-w-5xl bg-neutral-white px-2 md:pd-0 w-full z-10"
      style={backgroundColor ? { backgroundColor } : undefined}
    >
      <h2 className="text-h7 md:text-h6 py-8 font-semibold md:font-light text-neutral-dark-gray md:text-primary-teal text-center w-full">
        {title}
      </h2>
      <div className="md:flex md:justify-around c-locale-switcher__columns text-primary-gray">
        {entry?.columns?.map((column, n) => {
          return (
            <div key={n} className="grid grid-cols-2">
              {column.items?.map((region, m) => {
                return (
                  <div
                    className={classNames('mb-12 mx-5 col-span-2', {
                      'mb-12 mx-5': !region.locationRegionNoMargins,
                      'md:mb-12 md:mx-5': region.locationRegionNoMargins,
                      'col-span-2': !region.locationRegionIsonecolumn,
                      'md:col-span-2': region.locationRegionIsonecolumn,
                      'row-start-1': region.locationRegionIsfirstrow,
                    })}
                    key={m}
                  >
                    <h3 className="font-semibold text-p uppercase text-neutral-dark-gray">
                      {region.title}
                    </h3>
                    <div className="grid grid-cols-2 grid-flow-row-dense md:grid-cols-1">
                      {region.locales?.map((country, i) => {
                        return (
                          <a
                            key={i}
                            href={
                              country.subDomain
                                ? createLocaleUrl(country.subDomain, domain)
                                : country.href
                            }
                            className={classNames(
                              'text-p block whitespace-nowrap leading-7',
                              {
                                'col-start-1 md:col-start-auto':
                                  !region.locationRegionIsonecolumn &&
                                  i < Math.ceil((region.locales?.length ?? 0) / 2),
                                'col-start-2 md:col-start-auto':
                                  !region.locationRegionIsonecolumn &&
                                  i >= Math.ceil((region.locales?.length ?? 0) / 2),
                                'col-span-2': region.locationRegionIsonecolumn,
                                'col-span-2 col-start-auto':
                                  region.locationRegionHasspan2,
                              }
                            )}
                          >
                            {country.label}
                          </a>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          )
        })}
      </div>
    </div>
  )
}
